import { PipecatClient } from '@pipecat-ai/client-js';
import { LiveKitTransport } from '@pipecat-ai/livekit-transport';

// Dashboard "Test in Browser" through the self-hosted LiveKit server.
// The backend chooses the transport: a start response with livekit_url and token
// means LiveKit, anything else keeps the SmallWebRTC path. The token joins only
// this call's room; never log the response.

export const isLiveKitBrowserCall = (session) => Boolean(session?.livekit_url && session?.token);

export const startLiveKitBrowserCall = async ({ session, audioElement, onEnded }) => {
  const client = new PipecatClient({
    transport: new LiveKitTransport(),
    enableMic: true,
    enableCam: false,
    callbacks: {
      onTrackStarted: (track, participant) => {
        if (participant?.local || track.kind !== 'audio' || !audioElement) return;
        try { audioElement.setAttribute('playsinline', 'true'); } catch (_) {}
        audioElement.srcObject = new MediaStream([track]);
        audioElement.play?.().catch(() => {});
      },
      onBotDisconnected: () => onEnded(),
      onDisconnected: () => onEnded(),
    },
  });
  await client.connect({ url: session.livekit_url, token: session.token });
  return client;
};
